export default "__VITE_ASSET__1t6jSzr9__"